import { employeeAPI } from '@/utils/api'

export default {
  namespaced: true,
  
  state: {
    employeeProfile: null,
    employeeDocuments: [],
    employeeSalary: null,
    employeeAllowance: null,
    employeeContract: null,
    loading: false,
    error: null
  },
  
  mutations: {
    SET_EMPLOYEE_PROFILE(state, profile) {
      state.employeeProfile = profile
    },
    SET_EMPLOYEE_DOCUMENTS(state, documents) {
      state.employeeDocuments = documents
    },
    SET_EMPLOYEE_SALARY(state, salary) {
      state.employeeSalary = salary
    },
    SET_EMPLOYEE_ALLOWANCE(state, allowance) {
      state.employeeAllowance = allowance
    },
    SET_EMPLOYEE_CONTRACT(state, contract) {
      state.employeeContract = contract
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },
  
  actions: {
    async mobileGetEmployeeProfile({ commit }, empId) {
      commit('SET_LOADING', true)
      
      try {
        const response = await employeeAPI.mobileGetEmployeeProfile(empId)
        if (response.model) {
          commit('SET_EMPLOYEE_PROFILE', response.model)
        }
        return response
      } catch (error) {
        commit('SET_ERROR', error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },
    
    async mobileUpdateEmployeeProfile({ commit }, profileData) {
      commit('SET_LOADING', true)
      
      try {
        const response = await employeeAPI.mobileUpdateEmployeeProfile(profileData)
        if (response.model) {
          commit('SET_EMPLOYEE_PROFILE', response.model)
        }
        return response
      } catch (error) {
        commit('SET_ERROR', error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },
    
    async mobileGetEmployeeDocuments({ commit }, empId) {
      commit('SET_LOADING', true)
      
      try {
        const response = await employeeAPI.mobileGetEmployeeDocuments(empId)
        if (response.model) {
          commit('SET_EMPLOYEE_DOCUMENTS', response.model)
        }
        return response
      } catch (error) {
        commit('SET_ERROR', error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },
    
    async mobileSearchEmployeesForHandover({ commit }, searchText) {
      commit('SET_LOADING', true)
      
      try {
        console.log('Searching employees for handover:', searchText)
        const response = await employeeAPI.mobileSearchEmployeesForHandover(searchText)
        console.log('Employee search response:', response)
        
        if (response.model) {
          console.log('Found employees:', response.model)
          return response.model
        } else {
          console.log('No employees found')
          return []
        }
      } catch (error) {
        console.error('Error searching employees:', error)
        commit('SET_ERROR', error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },
    
    async mobileGetEmployeeSalary({ commit }, empId) {
      commit('SET_LOADING', true)
      
      try {
        console.log('Fetching employee salary for:', empId)
        const response = await employeeAPI.mobileGetEmployeeSalary(empId)
        console.log('Employee salary response:', response)
        
        if (response.model) {
          commit('SET_EMPLOYEE_SALARY', response.model)
          console.log('Salary data set in store:', response.model)
        }
        return response
      } catch (error) {
        console.error('Error fetching employee salary:', error)
        commit('SET_ERROR', error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },
    
    async mobileGetEmployeeAllowance({ commit }, empId) {
      commit('SET_LOADING', true)
      
      try {
        console.log('Fetching employee allowance for:', empId)
        const response = await employeeAPI.mobileGetEmployeeAllowance(empId)
        console.log('Employee allowance response:', response)
        
        if (response.model) {
          commit('SET_EMPLOYEE_ALLOWANCE', response.model)
          console.log('Allowance data set in store:', response.model)
        }
        return response
      } catch (error) {
        console.error('Error fetching employee allowance:', error)
        commit('SET_ERROR', error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },
    
    async mobileGetEmployeeContract({ commit }, empId) {
      commit('SET_LOADING', true)
      
      try {
        console.log('Fetching employee contract for:', empId)
        const response = await employeeAPI.mobileGetEmployeeContract(empId)
        console.log('Employee contract response:', response)
        
        if (response.model) {
          commit('SET_EMPLOYEE_CONTRACT', response.model)
          console.log('Contract data set in store:', response.model)
        }
        return response
      } catch (error) {
        console.error('Error fetching employee contract:', error)
        commit('SET_ERROR', error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },
    
    clearError({ commit }) {
      commit('SET_ERROR', null)
    }
  },
  
  getters: {
    employeeProfile: state => state.employeeProfile,
    employeeDocuments: state => state.employeeDocuments,
    employeeSalary: state => state.employeeSalary,
    employeeAllowance: state => state.employeeAllowance,
    employeeContract: state => state.employeeContract,
    loading: state => state.loading,
    error: state => state.error
  }
} 